const _import = require('./import/_import_' + process.env.NODE_ENV) //获取组件的方法
const routes = [{
  path: '/login',
  name: 'login',
  component: () => import('@/views/Login.vue'),
}]

const lastRoutes =
  [
    // {
    //   path: '/refresh',
    //   name: 'refresh',
    //   component: () => import('_c/error-page/refresh.vue'),
    //   hidden: true
    // },
    // {
    //   path: '/401',
    //   name: '401',
    //   component: () => import('_c/error-page/401.vue'),
    //   hidden: true
    // },
    //   {
    //     path: '*',
    //     name: '404',
    //     component: () => import('_c/error-page/404.vue'),
    //     hidden: true
    //   }
    { path: '*', redirect: '/' }
  ]

export {
  routes,
  lastRoutes
}